// 商品ランダム表示 — クライアントサイドでシャッフルする方式。
// 以前はLiquidの'now'を種にサーバー側でoffsetを計算していたが、Shopify側の
// レンダリングが短時間で同一の'now'値を返すことがあり(プラットフォーム側の
// 既知の挙動)、実際には毎回同じ商品が表示される事象が解消していなかった。
// ブラウザでの初回読み込み時に毎回シャッフルすることで、サーバー/エッジ側の
// キャッシュ挙動に一切依存しない、確実なランダム表示にする。
// JS無効時は、各プールに設定された表示件数ぶんの先頭商品がそのまま表示される
// (nth-childによるCSS側のフォールバック、sections/*.liquid内で定義)。
//
// 2026-07-15追記: 同一シリーズ(例: Sanrioの複数キャラクター違いグッズ)が
// 表示上位を占有しないよう、各カードのdata-group属性(商品タイトルの
// " - "より前の部分)を見て、同一グループから先頭側には最大2点までしか
// 採用しないよう並び替える。data-groupが無いカードにはこの制限をかけない。
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-shuffle-pool]').forEach(function (pool) {
    var items = Array.prototype.slice.call(pool.children);

    // まずランダムにシャッフル
    for (var i = items.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = items[i];
      items[i] = items[j];
      items[j] = tmp;
    }

    // 同一グループ(同一シリーズ)を先頭側で最大2点までに制限する
    var groupCounts = {};
    var picked = [];
    var leftover = [];

    items.forEach(function (item) {
      var group = item.getAttribute('data-group');
      if (!group) {
        picked.push(item);
        return;
      }
      var count = groupCounts[group] || 0;
      if (count < 2) {
        picked.push(item);
        groupCounts[group] = count + 1;
      } else {
        leftover.push(item);
      }
    });

    picked.concat(leftover).forEach(function (item) {
      pool.appendChild(item);
    });
  });
});
